import { Component, OnInit, Inject } from "@angular/core"
import {FormGroup, FormBuilder, Validators} from '@angular/forms'
import {CasoTareaModel, CasoTareaService} from 'src/app/services/casos_tareas.service'
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog'
import {TareaCasoService} from 'src/app/services/tareacaso.service'
import {MatSnackBar} from '@angular/material/snack-bar'
import {UserService} from 'src/app/services/user.service'
import { NotificacionService } from "src/app/services/notificaciones.service"

@Component({
  selector: 'observacion-final',
  templateUrl: './observacion-final.component.html',
  styleUrls: ['./observacion-final.component.css']
})
export class ObservacionFinalComponent implements OnInit {

  tareaFinalizadas: number = null

  form: FormGroup = this.fb.group({
    observacion_final: ['', Validators.required],
    //datos de validacion de documento
    validar_documento: ['', Validators.required],
    fecha_realizacion: ['', Validators.required],
    informado_correo: ['', Validators.required],
    email_usado: ['', [Validators.required, Validators.email, Validators.max(30)]],
    // correo: [values ? values.correo : '', [Validators.required, Validators.email, Validators.max(30)]],
    //datos para validar transacciones
    autorizar: ['', Validators.required],
    patron_fraude: ['', Validators.required],

  })

  constructor(
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<ObservacionFinalComponent>,
    @Inject(MAT_DIALOG_DATA) public caso: CasoTareaModel,
    public _tareas: TareaCasoService,
    public _casos: CasoTareaService,
    public _snackBar: MatSnackBar,
    public _users: UserService,
    public _notificacion: NotificacionService,

  ){}

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action)
  }

  ngOnInit(){
    this._tareas.getByCaso(this.caso._id).subscribe(tareas=>this.tareaFinalizadas = tareas.length)
    this.getCreadoPor()
  }

  async getCreadoPor(){
    this.caso.creadoPorc = (await this._users.getUserById(parseInt(this.caso.creadoPor)).toPromise()).payload.correo
  }

  guardarHistorial(comentario:string){
    this.caso.historial.push({
      usuario: `${sessionStorage.getItem("correo")}`,
      realizo:`Caso concluido y archivado. Comentario final: ${comentario}`,
      date: new Date()
    })
  }
  autorizar
  patron
  guardarHistorialValidaciones(){
    if(this.form.value.validar_documento == 'Si'){
      this.caso.historial.push({
        usuario: `${sessionStorage.getItem("correo")}`,
        realizo:`Documento valido`,
        date: new Date()
      })
    }else if(this.form.value.validar_documento == 'No'){
      this.caso.historial.push({
        usuario: `${sessionStorage.getItem("correo")}`,
        realizo:`Documento invalido`,
        date: new Date()
      })
    }else if(this.form.value.autorizar != ''){
      if(this.form.value.patron_fraude == 'Si'){
        this.caso.historial.push({
          usuario: `${sessionStorage.getItem("correo")}`,
          realizo:`Patron de fraude : Si`,
          date: new Date()
        })
        this.patron = 'Si'
      }else if(this.form.value.patron_fraude == 'No'){
        this.caso.historial.push({
          usuario: `${sessionStorage.getItem("correo")}`,
          realizo:`Patron de fraude : No`,
          date: new Date()
        })
        this.patron = 'No'
      }
      if(this.form.value.autorizar == 'Si'){
        this.caso.historial.push({
          usuario: `${sessionStorage.getItem("correo")}`,
          realizo:`Autorizado: Si`,
          date: new Date()
        })
        this.autorizar = 'Si'
      }else if(this.form.value.autorizar == 'No'){
        this.caso.historial.push({
          usuario: `${sessionStorage.getItem("correo")}`,
          realizo:`Autorizado: No`,
          date: new Date()
        })
        this.autorizar = 'No'
      }
      this._notificacion
      .notificacionAutorizarPatron(
        this.caso.creadoPor,
        this.caso.numero_caso,
        {msj:`Caso ${this.caso.numero_caso}  Autorizado: ${this.autorizar}, Patron de fraude: ${this.patron}`}
      )
      .toPromise();
    }
  }

  async finalizarDelTodo(){
    this.caso.estado = 'Archivado'
    this.caso.validar_documento = this.form.value.validar_documento
    this.caso.fecha_realizacion = this.form.value.fecha_realizacion
    this.caso.email_usado = this.form.value.email_usado
    this.caso.informado_correo = this.form.value. informado_correo
    this.caso.autorizar = this.form.value. autorizar
    this.caso.patron_fraude = this.form.value. patron_fraude
    this.guardarHistorialValidaciones()
    this.caso.archivetAt = new Date()
    this.guardarHistorial(this.form.value.observacion_final)
    const casonew = await this._casos.put(this.caso._id,this.caso).toPromise()
    this.openSnackBar('Caso concluido y archivado','x')
    this.dialogRef.close()
  }

}
